import './RefBonusItem.scss';
import { FC } from 'react';
import { RefBonusItemEntity } from './types';

const RefBonusItem: FC<RefBonusItemEntity> = ({ bgColor, icon, title, value }) => {
    return (
        <div
            className="ref-bonus-item"
            style={{ background: bgColor }}>
            <div className="ref-bonus-item__value">
                <img
                    src={icon}
                    alt=""
                />
                <h2>{value}</h2>
            </div>
            <h3>{title}</h3>
        </div>
    );
};

export default RefBonusItem;
